import MDButton from 'components/MDButton'
import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import MDModal from 'components/MDModal'
import MDInput from 'components/MDInput'
import Grid from '@mui/material/Grid'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import { useAppServices } from 'hook/services'
import { Link, useParams } from 'react-router-dom'
import { Button, Checkbox, FormControlLabel, Icon, TextField, Typography } from '@mui/material'
import Swal from 'sweetalert2'

function AddProduct({ open, onClose, snapshots, handleChange, locations, locationsLoader }) {
  const Service = useAppServices()
  const { company_id, app_id,user_id, app_type } = useParams()
  const [processing, setProcessing] = useState(false)
  const [workflowLoading, setWorkflowLoading] = useState(false)
  const [snapshot, setSnapshot] = useState(null)
  const [location, setLocation] = useState(null)
  const [installAppWorkflow, setInstallAppWorkflow] = useState(null)
  const [unInstallAppWorkflow, setUnInstallAppWorkflow] = useState(null)
  const [workflows, setWorkflows] = useState([])
  const [locationToken, setLocationToken] = useState(null)
  const [errors, setErrors] = useState({
    app_name: '',
    app_id: '',
    snapshot: '',
  })

  const validateForm = (formData) => {
    const newErrors = {}
    let isValid = true

    if (!formData.app_name.trim()) {
      newErrors.app_name = 'App Name is required'
      isValid = false
    }

    if (!formData.app_id.trim()) {
      newErrors.app_id = 'App ID is required'
      isValid = false
    }

    if (app_type === 'snapshot' && !snapshot) {
      newErrors.snapshot = 'Snapshot is required'
      isValid = false
    }

    setErrors(newErrors)
    return isValid
  }

  const showErrorAlert = (message) => {
    Swal.fire({
      icon: 'error',
      title: 'Validation Error',
      text: message,
      confirmButtonColor: '#3085d6',
    })
  }

  const handleLocation = async (location) => {
    setLocation(location)
    setWorkflowLoading(true)
    setInstallAppWorkflow(null)
    setUnInstallAppWorkflow(null)
    const { response } = await Service.snapshot_onboarding.get_workflows({
      query: `company_id=${company_id}&app_id=${app_id}&location_id=${location.value}`,
    })

    if (response) {
      setWorkflows(
        response?.data?.map((item) => ({
          label: item.name,
          value: item.id,
        }))
      )
      setWorkflowLoading(false)
      setLocationToken(response.location_token)
    }
  }
  const handleCreateSnapshot = async () => {
    try {
      const { response } = await Service.snapshots.create_agency_snapshot({
        payload: {
          snapshot_id: snapshot.value,
          location_id: location.value,
          company_id: company_id,
          snapshot_name: snapshot.label,
          user_id: user_id
        },
      })
      if (response?.success) {
        return {
          success: true,
          data: response.data,
        }
      } else {
        console.error(response?.error)
        return {
          success: false,
          data: null,
        }
      }
    } catch (error) {
      console.error(error.message)
      return {
        success: false,
        data: null,
      }
    }
  }
  const handleSubmit = async (e) => {
    e.preventDefault()

    const formData = {
      app_name: e.target.app_name.value,
      app_id: e.target.app_id.value,
      agency_type: e.target.agency_type.checked,
      sub_account_type: e.target.sub_account_type.checked,
      user_id: user_id
    }

    if (!validateForm(formData)) {
      const firstError = Object.values(errors).find((error) => error)
      if (firstError) {
        showErrorAlert(firstError)
      }
      return
    }

    setProcessing(true)
    let payload = {
      ...formData,
      main_app_id: app_id,
      company_id: company_id,
      app_type: app_type,
      ...(app_type === 'snapshot' && { snapshot: snapshot }),
    }
    if (app_type == 'snapshot') {
      const { success, data } = await handleCreateSnapshot()
      if (success) {
        payload.snapshot_ref_id = data?._id
      }
    }
    if (installAppWorkflow || unInstallAppWorkflow) {
      payload.workflows = {
        installAppWorkflow: installAppWorkflow,
        unInstallAppWorkflow: unInstallAppWorkflow,
      }
    }
    if (locationToken) {
      payload.location_token = locationToken
    }
    const { response } = await Service.snapshot_onboarding.create({ payload })
    if (response) {
      onClose()
      setProcessing(false)
      handleChange()
    } else {
      setProcessing(false)
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to create app',
        confirmButtonColor: '#3085d6',
      })
    }
  }

  return (
    <MDModal open={open} onClose={onClose}>
      <MDBox>
        <MDTypography component="h1" mb={3} variant="h5">
          App
        </MDTypography>

        <MDBox component="form" onSubmit={handleSubmit} role="form" sx={{ width: 335 }}>
          <Grid item md={12}>
            <MDBox mb={1}>
              <MDTypography variant="button" display="block" gutterBottom>
                App Name *
              </MDTypography>
              <MDInput
                defaultValue=""
                id="bootstrap-input"
                fullWidth
                placeholder="App Name"
                name="app_name"
                error={!!errors.app_name}
                helperText={errors.app_name}
              />
            </MDBox>
          </Grid>
          <Grid item md={12}>
            <MDBox mb={1}>
              <MDTypography variant="button" display="block" gutterBottom>
                App ID *
              </MDTypography>
              <MDInput
                defaultValue=""
                id="bootstrap-input"
                fullWidth
                placeholder="App ID"
                name="app_id"
                error={!!errors.app_id}
                helperText={errors.app_id}
              />
            </MDBox>
          </Grid>
          {app_type == 'snapshot' && (
            <>
              <Grid item md={12}>
                <MDBox mb={1} sx={{ fontSize: '15px' }}>
                  <MDTypography variant="button" display="block" gutterBottom>
                    Select Snapshot *
                  </MDTypography>
                  <Select
                    options={snapshots}
                    onChange={(e) => {
                      setSnapshot(e)
                      setErrors({ ...errors, snapshot: '' })
                    }}
                  />
                  {errors.snapshot && (
                    <MDTypography variant="caption" color="error">
                      {errors.snapshot}
                    </MDTypography>
                  )}
                </MDBox>
              </Grid>
              <Grid item md={12}>
                <MDBox mb={1} sx={{ fontSize: '15px' }}>
                  <MDTypography variant="button" display="block" gutterBottom>
                    Select Location (for snapshot)
                  </MDTypography>
                  <Select
                    isDisabled={locationsLoader}
                    isLoading={locationsLoader}
                    options={locations}
                    value={location}
                    onChange={(e) => {
                      setLocation(e)
                    }}
                  />
                </MDBox>
              </Grid>
            </>
          )}
          {/* {location?.value && (
            <>
              <Grid item md={12}>
                <MDBox mb={1} sx={{ fontSize: '15px' }}>
                  <MDTypography variant="button" display="block" gutterBottom>
                    Select Workflow For App Install (optional)
                  </MDTypography>
                  <Select
                    options={workflows}
                    isLoading={workflowLoading}
                    isDisabled={workflowLoading}
                    value={installAppWorkflow}
                    loadingMessage={'Please wait fetching workflows'}
                    onChange={(e) => {
                      setInstallAppWorkflow(e)
                    }}
                  />
                </MDBox>
              </Grid>
              <Grid item md={12}>
                <MDBox mb={1} sx={{ fontSize: '15px' }}>
                  <MDTypography variant="button" display="block" gutterBottom>
                    Select Workflow For App UnInstall (optional)
                  </MDTypography>
                  <Select
                    options={workflows}
                    isLoading={workflowLoading}
                    isDisabled={workflowLoading}
                    value={unInstallAppWorkflow}
                    loadingMessage={'Please wait fetching workflows'}
                    onChange={(e) => {
                      setUnInstallAppWorkflow(e)
                    }}
                  />
                </MDBox>
              </Grid>
            </>
          )} */}
          <Grid item md={12} mt={3}>
            <MDBox mb={1}>
              <MDTypography variant="button" display="block" gutterBottom>
                Distribution Type
              </MDTypography>
            </MDBox>
          </Grid>

          <Grid container item md={10}>
            <Grid item xs={5}>
              <MDBox mb={0.5}>
                <FormControlLabel control={<Checkbox name="agency_type" />} label="Agency" />
              </MDBox>
            </Grid>

            <Grid item xs={6}>
              <MDBox mb={0.5}>
                <FormControlLabel
                  control={<Checkbox name="sub_account_type" />}
                  label="Sub-Account"
                />
              </MDBox>
            </Grid>
          </Grid>

          <MDBox>
            <MDButton
              variant="gradient"
              color="info"
              type="submit"
              disabled={processing}
              loading={processing}
              sx={{ mt: 4, mb: 1 }}
              fullWidth
            >
              Add
            </MDButton>
          </MDBox>
        </MDBox>
      </MDBox>
    </MDModal>
  )
}
const CreateModal = ({ snapshots, handleChange, locations, locationsLoader }) => {
  const [openAddProduct, setOpenAddProduct] = useState(false)

  const closeAddProduct = (subscription) => {
    setOpenAddProduct(false)
  }

  return (
    <>
      <MDButton variant="gradient" color="info" onClick={() => setOpenAddProduct(true)}>
        <Icon>add</Icon>&nbsp; Add New
      </MDButton>
      <AddProduct
        open={openAddProduct}
        onClose={closeAddProduct}
        locationsLoader={locationsLoader}
        snapshots={snapshots}
        handleChange={handleChange}
        locations={locations}
      />
    </>
  )
}

export default CreateModal
